






















import Vue from 'vue'
import filesize from 'filesize'
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import OmnisearchResultSet from '@/modules/omnisearch/store/OmnisearchResultSet';
import OmnisearchResultItem from '@/modules/omnisearch/store/OmnisearchResultItem';


@Component
export default class UsersResultList extends Vue {
    @Prop({type: OmnisearchResultSet, default: () => new OmnisearchResultSet()})
    public set: OmnisearchResultSet

    public select (item: OmnisearchResultItem) {
        this.$emit('select', item)
        this.$router.push({
            name: 'user-detail',
            params: {
                id: item.id.toString(),
            },
        })
    }
}
